import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/theme.css'
import './styles/base.css'
import './styles/components.css'
import './styles/layout.css'
import './styles/parser.css'
import './styles/autobot.css'
import { App } from './App'
import { useAppStore } from '@/store/useAppStore'

// Dev-only: ручка стора для отладки/превью (не попадает в прод-бандл tree-shake'ом по DEV).
if (import.meta.env.DEV) {
  const w = window as unknown as { __store?: typeof useAppStore }
  w.__store = useAppStore
}

const root = document.getElementById('root')
if (!root) throw new Error('#root не найден')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
